var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInjuryFootRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 59,
    viewBox: "0 0 24 59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.948 1v12.419c-1.998 2.536-1.998 4.933 0 7.19 1.035 3.732-.036 8.598-3.215 14.6-4.768 9-3.504 16.584 5.424 21.635 8.929 5.051 14.614-4.097 13.813-9.093-.8-4.995-3.448-19.95-1.724-27.141 1.15-4.794.86-7.357-.869-7.69-1.198-1.025-1.798-4.998-1.798-11.92H6.947z",
    fill: "#FC5A56",
    stroke: "#FC5A56",
    fillRule: "evenodd",
    opacity: 0.495
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjuryFootRight);
export default __webpack_public_path__ + "static/media/injury-foot-right.9139859454e8de8c4413d9103c22c0da.svg";
export { ForwardRef as ReactComponent };